import useDeleteRegistration from "@/hooks/useDeleteRegistration";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from "@mui/material"
import React, { useEffect, useState } from "react";
import { DeleteRegistrationResponse, DeleteSponsorResponse, Registration, ResponseStatus, Sponsor } from "../../api/dtos";
import Loading from "./Loading";
import useDeleteSponsor from "@/hooks/useDeleteSponsor";

interface IDeleteSponsorModalProps {
    sponsor?: Sponsor | null;
    handleModalClose?: (refetch: boolean) => void;
}

const DeleteSponsorModal: React.FC<IDeleteSponsorModalProps> = ({sponsor, handleModalClose}) => {

    const {deleteSponsor, pending} = useDeleteSponsor(sponsor?.id);
    const [deleteAttempted, setDeleteAttempted] = useState<boolean>(false);
    const [deletingSponsor, setDeletingSponsor] = useState<Sponsor | undefined>();
    const [response, setResponse] = useState<DeleteSponsorResponse>();

    const deleteSuccess = !pending && deleteAttempted && !response?.responseStatus?.message;

    const handleClose = () => {
        if(handleModalClose){
            setDeleteAttempted(false);
            setDeletingSponsor(undefined);
            handleModalClose(deleteSuccess);
        }
    }

    const handleDelete = async () => {
        const resp = await deleteSponsor(sponsor?.id);
        if(response){
            setResponse(resp);
        }
    }

    useEffect(() => {
        return () => {
            setDeleteAttempted(false);
            setDeletingSponsor(undefined);
        }
    }, [])

    useEffect(() => {
        if(sponsor){
            setDeletingSponsor(sponsor);
        }
    }, [sponsor])

    useEffect(() => {
        if(!deleteAttempted && pending){
            setDeleteAttempted(true);
        }
    }, [pending])

    return (
        <Box>
            {
                pending && <Loading />
            }
            <Dialog 
                open={!!sponsor}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
            >
                <Box
                    sx={{
                        p: 2
                    }}
                >
                    {
                        deletingSponsor && (
                            <>
                                <Typography pl='22px' pt={2}
                                    variant="h4"
                                >
                                    Delete sponsor {sponsor?.sponsorName}
                                </Typography>
                                <DialogContent>
                                    {
                                        deleteAttempted ? 
                                            <>
                                            <DialogContentText>
                                                {
                                                    pending ? 
                                                    <Loading />
                                                    :
                                                    deleteSuccess ? "Sponsor deleted successfully" : "Could not delete sponsor"
                                                }
{/* 
                                                {deleteSuccess ? "Sponsor deleted successfully" : "Could not delete sponsor"} */}
                                            </DialogContentText>
                                            </>
                                        :
                                        <DialogContentText>
                                            Confirm you would like to delete the sponsor <strong>{sponsor?.sponsorName}</strong>. <br/> <br/> Note: Registrations already added under this sponsor will <strong>NOT</strong> be deleted.
                                        </DialogContentText>
                                    }
                                </DialogContent>
                                <DialogActions>
                                    {
                                        !pending && !deleteSuccess && (
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                size="large"
                                                sx={{
                                                    width: {
                                                        xs: '100%',
                                                        md: 'fit-content'
                                                    },
                                                    minWidth: '160px',
                                                    border: 'solid',
                                                    borderColor: 'secondary.main',
                                                    borderRadius: '20px',
                                                    '&:hover': {
                                                        backgroundColor: 'primary.main',
                                                        borderColor: 'primary.main'
                                                    }
                                                }}
                                                onClick={handleDelete}
                                            >
                                                <Typography
                                                    variant="body2"
                                                >   
                                                    Confirm
                                                </Typography>
                                            </Button>
                                        )
                                            
                                    }
                                    
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        size="large"
                                        onClick={handleClose}
                                        sx={{
                                            width: {
                                                xs: '100%',
                                                md: 'fit-content'
                                            },
                                            minWidth: '160px',
                                            color: 'seconday.main',
                                            borderRadius: '20px',
                                            borderColor: 'seconday.main',
                                            '&:hover': {
                                                color: 'primary.main',
                                                borderColor: 'primary.main'
                                            }
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                        >   
                                        {
                                            deleteSuccess ?
                                                "Back"
                                                :
                                                "Cancel"
                                        }
                                        </Typography>
                                    </Button>
                                </DialogActions>
                            </>
                        )
                    }
                </Box>
            </Dialog>
        </Box>
    );
}

export default DeleteSponsorModal;